import iframeStore from "../pages/IframeNew/iframe-store.tsx";

/** Path prefixes that are NOT part of the console (hub, labs, auth, etc.). */
const NON_CONSOLE_PATH_PREFIXES = [
	"/auth",
	"/pricing",
	"/password-reset",
	"/mfa_revert",
	"/register",
	"/login",
	"/forgot-password",
	"/mcp-auth",
	"/plugin-login",
	"/pluginAuth-status",
	"/user-info",
	"/account-verification",
	"/playground-hub",
	"/labs",
	"/automotive",
	"/apps",
	"/page-not-found",
	"/mobile-not-supported",
];

/**
 * True if the pathname is a "console" route (dashboard, account, models, etc.)
 * that is shown inside the platform-frontend migration iframe.
 */
export function isConsolePath(pathname: string): boolean {
	const normalized = pathname.startsWith("/") ? pathname : `/${pathname}`;
	if (normalized === "/") return true;
	return !NON_CONSOLE_PATH_PREFIXES.some((prefix) => normalized === prefix || normalized.startsWith(prefix + "/"));
}

export function isMigrationIframe(): boolean {
	return window !== window.parent && !iframeStore.isIframe();
}
